import React, { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import LicService from '../../../services/licitacao';
import InfiniteScroll from '../../auth/utils/infiniteScroll';
import Licitacao from './lic';
import Moment from 'moment';

const ListarLics = () => {
    const [lics, setLics] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [cod, setCod] = useState(null);
    const [numLics, setNumLics] = useState(null);
    const [aindaTem, setAindaTem] = useState(true);
    const [tipo, setTipo] = useState("");
    const pathName = window.location.pathname;

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const getTipo = async (path) => {
        switch (path) {
            case '/transparencia/licitacao/covid':
                return { tipo: "", covid: true, todas: false };
                break;
            case '/transparencia/licitacao/aviso':
                setTipo("Avisos");
                return { tipo: "Avisos", covid: false, todas: false };
                break;
            case '/transparencia/licitacao/andamento':
                setTipo("Andamento")
                return { tipo: "Andamento", covid: false, todas: false };
                break;
            case '/transparencia/licitacao/encerradas':
                setTipo("Encerradas")
                return { tipo: "Encerradas", covid: false, todas: false };
                break;
            default:
                return { tipo: null, covid: false, todas: true };
                break;
        }
    };

    const fetchLicsIn = async () => {
        const { tipo, covid, todas } = await getTipo(pathName);
        const responseNum = await LicService.numLic({ todas: todas, situacao: tipo, covid: covid });
        const totalLics = parseInt(responseNum.data);
        setNumLics(totalLics);
        const response = await LicService.modalidade({ limit: true, situacao: tipo, covid: covid });

        if (response.data.length >= 1) {
            setLics(response.data);
            setVazio(false);
            setCod(response.data[response.data.length - 1]["cod_lic"]);
            setAindaTem(response.data.length === 20);
        } else {
            setLics([]);
            setVazio(true);
            setAindaTem(false);
        }
    };

    const fetchLics = async () => {
        await seraQueAcabou();
        const { tipo, covid, todas } = await getTipo(pathName);

        const response = await LicService.modalidade({ limit: true, situacao: tipo, covid: covid, cod_lic: cod });

        if (response.data.length >= 1) {
            setLics((prevLics) => [...prevLics, ...response.data]);
            setCod(response.data[response.data.length - 1]["cod_lic"]);
            if (response.data.length < 20) {
                setAindaTem(false);
            }
        } else {
            setAindaTem(false);
        }
    };

    const seraQueAcabou = async () => {
        if (lics.length >= numLics + 1) {
            setAindaTem(false);
        } else {
            setAindaTem(true);
        }
    };

    useEffect(() => {
        fetchLicsIn();
    }, [window.location.pathname]);

    return (
        <Fragment>
            <FormBusca
                setLics={setLics}
                setVazio={setVazio}
                lics={lics}
                setAindaTem={setAindaTem}
                fetchLicsIn={fetchLicsIn}
                situacao={tipo}
            />

            {vazio ? (
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            ) : (
                <Fragment>
                    <Row xs={1}>
                        {lics.map((lic, index) => (
                            <Licitacao lic={lic} key={index} />
                        ))}
                    </Row>
                    {aindaTem ? (
                        <Fragment>
                            <p>Carregando mais licitações...</p>
                            <InfiniteScroll Listar={fetchLics} />
                        </Fragment>
                    ) : (
                        <p>Todas as licitações já foram exibidas :)</p>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

export default ListarLics;
